const brImpersonate = {
  impersonate: {
    action: 'Me transformar ✨',
    confirmation: 'Tem certeza que deseja fazer login como {name} ?',
    details: 'Ao clicar no botão abaixo <b>Sim, tenho!</b>, você será autenticado como:',
    details2: 'Use essa função com responsabilidade e tenha cuidado com suas ações.',
    perform: 'Sim, tenho!',
    revert: 'Voltar ao meu usuário original',
    name: 'Nome',
    email: 'E-mail',
  }
}

export default brImpersonate
